import { DataRoomStatus } from './data-room.enums';
import { SpaceKind } from './space.enums';

export interface SpaceListItemBase {
  createdAt: string;
  description: null | string;
  id: string;
  name: string;
  rootFolderId: null | string;
  updatedAt: string;
}

export interface WorkspaceMetrics {
  // Reported as 0 until the analytics supply it (SPACE_CONTRIBUTOR_COUNT_UNTIL_ANALYTICS).
  contributorCount: number;
  fileCount: number;
  folderCount: number;
  lastActivityAt: null | string;
  totalSize: number;
}

export interface DataRoomMetrics {
  downloadCount: number;
  fileCount: number;
  lastActivityAt: null | string;
  // The file this room's visitors opened most, for the strip at its root (20.4 §5). Null until
  // somebody has opened one.
  mostViewedFile: null | { id: string; name: string };
  recipientCount: number;
  viewCount: number;
  viewingTimeSeconds: number;
  visitorCount: number;
}

export interface WorkspaceListItem extends SpaceListItemBase {
  kind: SpaceKind.WORKSPACE;
  metrics: WorkspaceMetrics;
}

export interface DataRoomListItem extends SpaceListItemBase {
  kind: SpaceKind.DATA_ROOM;
  metrics: DataRoomMetrics;
  status: DataRoomStatus;
}

export type SpaceListView = DataRoomListItem | WorkspaceListItem;

// The three toggles of the Data Room Settings modal. They stay off the list view on purpose: a
// Home card never renders them, and a list that carries settings invites reading them from a row
// that was never meant to be the source of truth.
export interface DataRoomSettings {
  hideStakeholderNames: boolean;
  includeCapTable: boolean;
  showInFolderStats: boolean;
}

export type DataRoomDetailView = { settings: DataRoomSettings } & DataRoomListItem;

export const isDataRoomListItem = (space: SpaceListView): space is DataRoomListItem =>
  space.kind === SpaceKind.DATA_ROOM;

export const isWorkspaceListItem = (space: SpaceListView): space is WorkspaceListItem =>
  space.kind === SpaceKind.WORKSPACE;
